import React from "react";
import { useSearchParams } from "react-router-dom";
import { IconHome, IconCalendar } from "@tabler/icons-react";
import PageContent from "../shared/PageContent/PageContent";
import SubNav from "../shared/Navigation/SubNav";
import HomePage from "../Home/HomePage";
// import RepDashboard from "./RepDashboard";
// import ManagerDashboard from "./ManagerDashboard";
// import CompanyAdminDashboard from "./CompanyAdminDashboard";
// import ReppiAdminDashboard from "./ReppiAdminDashboard";

const TAB_PARAM = "tab";

const HOME_TABS = [
  { id: "home", label: "Home", icon: IconHome },
  { id: "calendar", label: "Calendar", icon: IconCalendar },
];

function DashboardPage() {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabParam = searchParams.get(TAB_PARAM);
  const activeTab = HOME_TABS.some(tab => tab.id === tabParam)
    ? tabParam
    : "home";

  const handleTabChange = tab => {
    setSearchParams(
      prev => {
        const next = new URLSearchParams(prev);
        if (tab.id === "home") {
          next.delete(TAB_PARAM);
        } else {
          next.set(TAB_PARAM, tab.id);
        }
        return next;
      },
      { replace: true }
    );
  };

  return (
    <PageContent
      customHeader={
        <SubNav
          tabs={HOME_TABS}
          activeId={activeTab}
          onChange={handleTabChange}
          ariaLabel="Home sections"
        />
      }
    >
      {activeTab === "home" && <HomePage />}
    </PageContent>
  );
}

export default DashboardPage;
